<template>
    <v-expansion-panels v-model="cohortPanel" multiple accordion>
        <v-expansion-panel v-for="(category,index) in Categories" :key="index">
            <v-expansion-panel-header><span><strong>{{ category.categoryName }}</strong><br /> <span class="caption">Max Selections: {{category.maxSelection}}</span></span></v-expansion-panel-header>
            <v-expansion-panel-content>
                <v-list dense>
                    <div v-if="category.maxSelection==1">
                        <v-radio-group v-model="cohortFilterRadios[index]">
                            <v-radio v-for="keyval in category.keyValues"
                                     :key="keyval.itemName"
                                     :label="keyval.itemName"
                                     :value="keyval.itemValue"
                                     color="indigo"
                                     @change="onCheckboxChange"
                                     class="pl-3 ma-0"></v-radio>
                        </v-radio-group>
                    </div>
                    <div v-else>
                        <v-list-item-group class="ma-0 pa-0">
                            <v-list-item v-for="keyval in category.keyValues" :key="keyval.itemName" class="ma-0 pa-0">
                                <v-checkbox :label="keyval.itemName"
                                            color="indigo"
                                            v-model="keyval.isSelected"
                                            @change="onCheckboxChange"
                                            :disabled='disabledFunc(category) && !keyval.isSelected' class="ma-0 pa-0"></v-checkbox>
                            </v-list-item>
                        </v-list-item-group>
                    </div>
                </v-list>
            </v-expansion-panel-content>
            <!--<v-list dense>
                <v-list-tile v-for="keyval in category.keyValues" :key="keyval.itemName">
                    <v-list-tile-content style="align-items:baseline">
                        <v-checkbox :label="keyval.itemName"
                                    color="indigo"
                                    v-model="keyval.isSelected"
                                    @change="onCheckboxChange"
                                    :disabled='disabledFunc(category) && !keyval.isSelected'></v-checkbox>
                    </v-list-tile-content>
                </v-list-tile>
            </v-list>-->
        </v-expansion-panel>
    </v-expansion-panels>
</template>
<script>
    export default {
        components: {
        },
        props: ['Categories'],
        data() {
            return {
                //panel: [],
            }
        },
        computed: {
            modelCohortFilters: {
                get() {
                    return this.$store.state.CategoriesStore.modelCohortFilters;
                },
                //set(newVal) {
                //    //this.$store.dispatch('Categories/setmodelYourDataFilters', newVal);
                //    this.$store.state.CategoriesStore.modelCohortFilters = newVal;
                //}
            },
            cohortFilterRadios: {
                get() {
                    return this.$store.state.CategoriesStore.cohortFilterRadios;
                },
                set(newVal) {
                    this.$store.state.CategoriesStore.cohortFilterRadios = newVal;
                }
            },
            cohortPanel: {
                get() {
                    return this.$store.state.CategoriesStore.cohortPanel;
                },
                set(newVal) {
                    this.$store.state.CategoriesStore.cohortPanel = newVal;
                }
            }
        },
        methods: {
            disabledFunc: function (x) {
                var count = 0;
                x.keyValues.map(function (m) {
                    if (m.isSelected)
                        count = count + 1;
                });
                if (x.maxSelection == '*')
                    return true;
                if (count >= x.maxSelection)
                    return true;
                else
                    return false;
            },
            onCheckboxChange() {
                //this.$store.state.CategoriesStore.tblCohortFilters = this.Categories;
                this.$store.state.CategoriesStore.cohortFiltersApplied = true;
                this.$store.state.CategoriesStore.modelCohortFilters = this.Categories;
                //this.Categories.filter(function (l) {
                //    return l.categoryName
                //}).map(function (l) {
                //    var Categoryname = l.categoryName
                //    var diplay = l.displaySection
                //    var maxselection = l.Maxselection
                //    var CategoryId = l.CategoryId
                //    return l.keyValues.filter(function (l) {
                //        return l.isSelected
                //    }).map(function (l) {
                //        return {
                //            category: Categoryname,
                //            displaySection: diplay,
                //            Maxselection: maxselection,
                //            CategoryId: CategoryId,
                //            keyValues: [{
                //                itemName: l.itemName,
                //                itemValue: l.itemValue,
                //                sortOrder: l.sortOrder,
                //                isSelected: l.isSelected
                //            }]
                //        };

                //    })
                //})
            },
        }
    }
</script>
<style>
</style>